export default __webpack_public_path__ + "static/media/check-circle.24e5c57c.svg";